import axios from '@axios'

const route = 'sales'

export default {
  namespaced: true,
  state: {
    sales: [],
  },
  getters: {
    getSales(state) {
      return state.sales
    },
  },
  mutations: {
    setSales(state, sales) {
      state.sales = sales
    },
  },
  actions: {
    loadSales(context, {
      itemsPerPage, page, search, filters,
    }) {
      const pagination = `?page=${page}&items_per_page=${itemsPerPage}`

      return axios.post(`${route}/sales${pagination}`, filters)
    },
    getDailySales(state, date) {
      return axios.get(`${route}/daily_sales` + `?date=${date}`)
    },
    getMovementCash(state, date) {
      return axios.get(`${route}/movement_cash` + `?date=${date}`)
    },
    exportExcel(context, filters) {
      return axios.post(`${route}/export_excel`, filters, { responseType: 'blob' })
    },

  },
}
